// extracted by mini-css-extract-plugin
export default {"container":"joZq0X","dot":"_6agxJ","small":"qhN948","opacitychange":"J3cfez"};